import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import ModesColumns from "../../../models/ColumnDefinitions/ModeColumns";
import ModeSearch from "../../../models/search/ModeSearch";
import { getModesNamesWithPagination } from "../../../services/presetDeviceSchedule";
import TableTab from "../../tabs/table-tab";
import { DEF_PG_SIZE_SUB_MIN } from '../../../constants/maximum-page-size';
import {getListQueryForSettingIds} from "../../../utilities/modeTypeUtils";

interface WizardDescriptionProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    selectedMode: any;
    setSelectedMode: (mode: any) => void;
    profileType: string;
    presetType: string;
}

export const WizardDescription: FC<WizardDescriptionProps> = ({ onBack = undefined, onNext = undefined, selectedMode, setSelectedMode, profileType, presetType }) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.selectedAMode);
    const onRowClicked = (rowData: any) => {
        const newSelectedMode = {
            ...selectedMode,
            id: rowData.id,
            name: rowData.originalName,
            settingTypeId: rowData.settingTypeId,
        }
        setSelectedMode(newSelectedMode);

        handleNext({} as React.MouseEvent<HTMLButtonElement, MouseEvent>, newSelectedMode)
    }

    const handleBack = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (onBack) {
            onBack(e);
        }
    };

    const handleNext = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, mode?: any): Promise<void> => {
        mode = mode ? mode : selectedMode;
        if (onNext && ((mode && mode.id) || mode.id)) {
            setFieldValue('settingIdToCopy', mode.id);
            setFieldValue('settingTypeId', mode.settingTypeId);
            onNext({ ...e, itemName: mode ? mode.name : mode.name, deviceScheduleItem: values })
        }
    }

    return <div className="flex flex-col pt-3 pr-3 h-full">
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                usePagination
                useTable
                useSort
                useSearch
                useFilter
                dataMethod={(listQuery) => getModesNamesWithPagination(profileType, getListQueryForSettingIds(presetType, listQuery))}
                tableDescriptor={ModesColumns}
                searchDescriptor={ModeSearch}
                maxPageSize={DEF_PG_SIZE_SUB_MIN}
                canExportReport={false}>
                <TableTab
                    title={title}
                    selectRows={false}
                    onRowClicked={(data) => onRowClicked(data)}
                    tableId={'modeTable'}
                    cyName="wizardDescription"
                    customHighlightRow={{ fieldName: "settingTypeId", comparisonValue: values.settingTypeId }}
                />
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={handleBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${!(selectedMode.id) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                    type='button'
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>;
};

